import { getGoogleMapsApiKey } from "@/utils/utils";
import { importLibrary, setOptions } from "@googlemaps/js-api-loader";
import { createContext, ReactNode, use, useEffect, useState } from "react";
import { DEFAULT_LOCALE } from "../i18n";

export type GoogleMapsAPIContextType = {
  googleApi?: google.maps.PlacesLibrary;
};

const GoogleMapsAPIContext = createContext<GoogleMapsAPIContextType | undefined>(undefined);

type Props = {
  children: ReactNode;
};

const googleMapsApiKey = getGoogleMapsApiKey();

setOptions({ key: googleMapsApiKey, language: DEFAULT_LOCALE, region: "SK" });

export const GoogleMapsApiProvider = ({ children }: Props) => {
  const [googleApi, setGoogleApi] = useState<google.maps.PlacesLibrary>();

  useEffect(() => {
    if (googleMapsApiKey) {
      importLibrary("places")
        .then((value) => {
          setGoogleApi(value);
        })
        .catch((error) => console.error("Error occurred while loading Google Maps Places API.", error));
    }
  }, []);

  return <GoogleMapsAPIContext value={{ googleApi }}>{children}</GoogleMapsAPIContext>;
};

export const useGoogleMapsApi = () => {
  const context = use(GoogleMapsAPIContext);

  if (!context) {
    throw new Error("useGoogleMapsApi must be used within a GoogleMapsApiProvider");
  }

  return context;
};
